import { useEffect, useState } from "react";
import { CrudItemData } from "../../toolympus/api/useSimpleCrud";
import { Comment } from "../../toolympus/components/Comments";
import { useDialogState } from "../../toolympus/components/primitives";
import { CaseRecord } from "./useCaseRecordsList";
import { useValidationErrors } from "../../toolympus/components/schemed";

export const StatusLabel = {
  "considered-done": "заполнено",
  "confirmed-done": "подтверждено",
  "default": "в процессе",
  "needs-fixing": "требуется доработка",
}

export const StatusColor = {
  "considered-done": "#05a605",
  "confirmed-done": "#1F9DD9",
  "needs-fixing": "#cc0000",
  "default": "#e5b902",
}


const StatusNeedsComment: Record<string, boolean> = {
  "needs-fixing": true,
}

const isCommentRequired = (status: string) => {
  return !!StatusNeedsComment[status];
}

interface StageT {
  newStatus: CaseRecord["review_status"] | null,
  comment: string,
}

const DefaultStage: StageT = {
  newStatus: null,
  comment: "",
}


export const useCaseRecordReviewStatus = (data: CrudItemData<CaseRecord>, sendComment: (c: Partial<Comment>) => Promise<Comment>) => {
  const dialog = useDialogState();

  const [stage, setStage] = useState<StageT>(DefaultStage);
  const errors = useValidationErrors();

  useEffect(() => {
    if(!dialog.isOpen) {
      setStage(DefaultStage)
      errors.clearErrors();
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialog.isOpen]);

  const stageX = stage.newStatus ? "comment" : "initial";


  const update = (newStatus: CaseRecord["review_status"]) => {
    if(!newStatus) {
      return;
    }

    if(stageX === "initial" && isCommentRequired(newStatus)) {
      setStage({
        newStatus: newStatus,
        comment: "",
      })
    } else if(stageX === "comment" && !stage.comment?.trim() && isCommentRequired(newStatus)) {
      errors.captureErrors({ response: { data: { errors: { comment: "необходимо заполнить" }}}})
    } else {
      errors.clearErrors();
      data.save({ review_status: newStatus });
      sendComment({
        comment: `${(StatusLabel as any)[newStatus || ""]}${stage.comment ? ":\n" : ""}${stage.comment || ""}`
      })
      dialog.close();
      
      setStage(DefaultStage);
    }
  }

  const status = data.data?.review_status;

  return {
    status,
    statusInfo: {
      label: StatusLabel[status || "default"],
      color: StatusColor[status || "default"],
    },
    statusDatetime: data.data?.review_status_datetime,
    update,
    dialog,
    comment: {
      value: stage.comment,
      update: (v: string) => setStage(x => ({ ...x, comment: v })),
      isRequired: isCommentRequired(stage.newStatus || ""),
    },
    errors,
    stage,
    stageX,
  }
}

export type CaseRecordReviewStatusData = ReturnType<typeof useCaseRecordReviewStatus>;
